import React, { useEffect, useState, useContext } from 'react';
import './Header2.css';
import './Search.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { NavLink, useNavigate } from 'react-router-dom';
import { HomeContext } from '../Context/HomeContext';

export default function Header2() {
  const [menu, setMenu] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const { homeData } = useContext(HomeContext);
  
  // First check if homeData exists and has allCategories property
  // If it exists, ensure it's properly converted to an array
  const categories = homeData?.allCategories ? 
    (Array.isArray(homeData.allCategories) ? 
      homeData.allCategories : 
      Object.values(homeData.allCategories)) : 
    [];

  // Use state to track window width instead of direct access
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1140);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    
    // Add resize listener to update isMobile state
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1140);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    setIsModalOpen(false);
    setSearchTerm('');
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const toggleMenu = () => {
    setMenu(!menu);
    setOpenDropdowns({});
  };

  const toggleDropdown = (slug) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [slug]: !prev[slug],
    }));
  };

  const handleCategoryClick = (cat, e) => {
    if (isMobile && cat.sub_categories && getSubCategories(cat.sub_categories).length > 0) {
      if (e.target.classList.contains('dropdown-arrow')) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(cat.slug);
      } else {
        navigate(`/category/${cat.slug}`);
        setMenu(false);
        setOpenDropdowns({});
      }
    } else {
      navigate(`/category/${cat.slug}`);
      setMenu(false);
      setOpenDropdowns({});
    }
  };

  const handleSubcategoryClick = (slug, e) => {
    e.preventDefault();
    e.stopPropagation();
    // Make sure we're navigating with the correct slug
    if (slug) {
      navigate(`/subcategory/${slug}`);
      setMenu(false);
      setOpenDropdowns({});
    }
  };

  // Helper function to safely parse and return subcategories
  const getSubCategories = (subCats) => {
    if (!subCats) return [];
    
    try {
      // If it's already an array, return it
      if (Array.isArray(subCats)) return subCats;
      
      // If it's a string, try to parse it
      if (typeof subCats === 'string') {
        const parsed = JSON.parse(subCats);
        return Array.isArray(parsed) ? parsed : [];
      }
      
      // If it's an object with numeric keys, convert to array
      if (typeof subCats === 'object') {
        return Object.values(subCats);
      }
    } catch (error) {
      console.error("Error parsing subcategories:", error);
    }
    
    return [];
  };

  return (
    <div className='section'>
      <div className='part1'>
        <div className='img1'>
          <NavLink to={'/'}>
            <img src='/funfillia_logo_white.png' width='170px' height='80px' alt='Funfillia' title='Funfillia' />
          </NavLink>
        </div>

        <div className='subpart1'>
          <div onClick={toggleMenu}>
            {menu ? <span className='icon1'>&#10005;</span> : <span className='icon2'>&#8801;</span>}
          </div>

          <ul className={menu ? 'lists active' : 'lists'}>
            <li className='category-menu'>
              <NavLink to='/' onClick={() => setMenu(false)} className="w-full block">
                Home
              </NavLink>
            </li>

            {categories.map(cat => {
              const subCategories = getSubCategories(cat.sub_categories);
              const hasSubcats = subCategories.length > 0;
              
              return (
                <li
                  className="category-menu"
                  key={cat.slug}
                  onClick={(e) => handleCategoryClick(cat, e)}
                >
                  <span className="navlink1">
                    {cat.name}
                    {isMobile && hasSubcats && (
                      <span
                        className="dropdown-arrow"
                        style={{ float: 'right', marginRight: '20px' }}
                      >
                        {openDropdowns[cat.slug] ? '▲' : '▼'}
                      </span>
                    )}
                  </span>

                  {hasSubcats && (
                    <ul
                      className={`subcategory-dropdown ${isMobile && openDropdowns[cat.slug] ? 'show' : ''}`}
                    >
                      {subCategories.map(sub => (
                        <li key={sub.slug || sub.id} onClick={(e) => {
                          e.stopPropagation();
                          handleSubcategoryClick(sub.slug || sub.id, e);
                        }}>
                          <span className="dropdown-item">
                            {sub.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}

            <li className='category-menu'><NavLink to='/AboutUs' onClick={() => setMenu(false)}>About Us</NavLink></li>
            <li className='category-menu'><NavLink to='/ContactUs' onClick={() => setMenu(false)}>Contact Us</NavLink></li>
          </ul>
        </div>

        <div className="search-icon" onClick={() => setIsModalOpen(!isModalOpen)}>
          <i className="fa fa-search"></i>
        </div>

        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>What are you looking for?</h2>
              <input
                type="text"
                className="search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleSearchKeyPress}
              />
              <button onClick={handleSearch} className="search-button">Search</button>
              <button className="close-button" onClick={() => setIsModalOpen(false)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}